module.exports = __webpack_public_path__ + "img/pop_1.11f43bb5.gif";